import { categoryColors } from './mockData';

export const calculateStats = (transactions) => {
  const totalIncome = transactions
    .filter((t) => t.type === 'income')
    .reduce((sum, t) => sum + t.amount, 0);
  const totalExpenses = transactions
    .filter((t) => t.type === 'expense')
    .reduce((sum, t) => sum + t.amount, 0);
  return { totalBalance: totalIncome - totalExpenses, totalIncome, totalExpenses };
};

export const getCategorySpending = (transactions) => {
  const map = {};
  transactions
    .filter((t) => t.type === 'expense')
    .forEach((t) => { map[t.category] = (map[t.category] || 0) + t.amount; });
  return Object.entries(map)
    .map(([category, amount]) => ({ category, amount, color: categoryColors[category] || '#64748b' }))
    .sort((a, b) => b.amount - a.amount);
};

export const getBalanceTrends = (transactions) => {
  const sorted = [...transactions].sort((a, b) => new Date(a.date) - new Date(b.date));
  const map = {};
  sorted.forEach((t) => {
    const d = t.date.substring(0, 7);
    if (!map[d]) map[d] = { income: 0, expenses: 0 };
    if (t.type === 'income') map[d].income += t.amount;
    else map[d].expenses += t.amount;
  });
  let bal = 0;
  return Object.entries(map).map(([date, data]) => {
    bal += data.income - data.expenses;
    return { date, balance: bal, income: data.income, expenses: data.expenses };
  });
};

export const formatCurrency = (amount) =>
  new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 0 }).format(amount);

export const formatDate = (dateString) =>
  new Intl.DateTimeFormat('en-US', { month: 'short', day: 'numeric', year: 'numeric' }).format(new Date(dateString));

export const formatMonth = (dateString) => {
  const [y, m] = dateString.split('-');
  return new Date(+y, +m - 1).toLocaleString('en-US', { month: 'short' });
};

export const getMonthName = (dateString) => {
  const [y, m] = dateString.split('-');
  return new Date(+y, +m - 1).toLocaleString('en-US', { month: 'long', year: 'numeric' });
};

export const exportToCSV = (transactions) => {
  const headers = ['Date', 'Description', 'Category', 'Type', 'Amount'];
  const rows = transactions.map((t) => [t.date, t.description, t.category, t.type, t.amount]);
  const csv = [headers, ...rows].map((r) => r.map((c) => `"${c}"`).join(',')).join('\n');
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const a = document.createElement('a');
  a.href = URL.createObjectURL(blob);
  a.download = `transactions_${new Date().toISOString().split('T')[0]}.csv`;
  a.click();
};
